(function () {
    'use strict';

    /*
     * Send Package Controller
     */

    angular.module('ShargoApp').controller('ProfileController', function ($scope, $rootScope, $http, $window, $timeout, _, Configuration, AuthService, toolsService, DeliversService) {
		$rootScope.pageConfiguration = {
			footer: true,
			header: {
				solid: -1000,
				background: 'linear-gradient(to bottom, #fed256, #ffbd4d)',
				preheader: false,
				headerLink: $rootScope.url('home'),
				headerLogo: $rootScope.device.isDesktop ? Configuration.siteDomain + "/img/header/shargo-white.svg" : Configuration.siteDomain + "/img/header/shargo-mobile.svg",
				logIn: true,
				dashboard: true,
				callToAction: {
					link: $rootScope.device.isDesktop ? $rootScope.url('sendpackage') : $rootScope.url('contact'),
					text: $rootScope.device.isDesktop ? 'header.ask4Shargo' : 'header.contact',
					target: '',
					hide: false,
					disabled: false
				},
				profile: true
			}
		};

        /* User Check & info */
        $scope.user = {};
        $scope.dialogFillFiscalInformation = false;
        $scope.forms = {
            show: {},
            check: {},
            text: {}
        };

        $scope.form = {
            show: {}
        };

        getUserGeneralInfo();
        getUserTransportInfo();
        getUserPromotionsInfo();
        getUserInvoices();

        function getUserInvoices() {
			$("#invoice-placeholder").show();
            $timeout(function() {
                $scope.invoices = [];
                DeliversService.getInvoices().then(function (res) {
                    if(res.data) {
                        $scope.invoices = res.data;
                        if($scope.invoices && $scope.invoices.length > 0) {
							$("#invoice-placeholder").hide();
                        }
                    }
                });
            }, 1000);
        }

        $scope.downloadInvoice = function(invoiceBundle) {
            console.log("downloadInvoice! ", invoiceBundle);
            $window.location.href = 'https://' + invoiceBundle.url;
/*
            DeliversService.downloadInvoice(id).then(function (res) {
                console.log("antes de window open");
                var data = res.data;
                console.log("DATA",data);
                var blob = new Blob([data], { type:"application/pdf" });
                console.log("BLOB", blob);
                if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE
                    console.log("downloadInvoice > IE case");
                    window.navigator.msSaveOrOpenBlob(blob, invoiceName);
                } else if(!supportsDownloadAttribute) { // Safari
                    console.log("downloadInvoice > Safari case");
                    win.location = $window.URL.createObjectURL(blob);
                } else { // Chrome, Firefox, Brave
                    console.log("downloadInvoice > other browsers case");
                    var anchor = angular.element('<a/>');
                    var oneAnchor = anchor.attr({
                        id: 'invoice-link-'+ id,
                        href: window.URL.createObjectURL(blob),
                        target: '_blank',
                        download: invoiceName
                    })[0];
                    document.body.appendChild(oneAnchor);
                    $timeout(function () {
                        oneAnchor.click();
                        document.body.removeChild(oneAnchor);
                    });
                }
            });*/
        };

        /* Edit Profile */

        $scope.activePopUp = function (field1, field2, field3) {
            console.log("ActivePopUp", field1, field2, field3);
            toolsService.setFalse($scope.forms.check);
            $scope.forms.show[field1] = $rootScope.blur[field2] = $rootScope.blur[field3] = true;
		};

        $scope.getTokenByMail = function (field1, field2, field3) {
            console.log('requesting token');
            $http.post(Configuration.apiUrl + '/senders/token/emailjwt', {}, {
                headers: {
                    'x-token': localStorage.getItem('xtoken'),
                    'x-userid': localStorage.getItem('userid')
                }
            })
        };

        $scope.activePopUpMGM = function () {
            console.log("ActivePopUpMGM");
			$rootScope.mgm.show.promotion = "invitation";
			$rootScope.blur.MGMPopUppromotion = $rootScope.blur.MGMPopUppromotionForced = true;
		};

        $scope.cancelPopUp = function (field1, field2, field3) {
            $scope.forms.show[field1] = $rootScope.blur[field2] = $rootScope.blur[field3] = false;
        };

        $scope.clickOutPopUp = function (field1, field2, field3) {
            if ($scope.forms.show[field1]) {
                $scope.forms.show[field1] = $rootScope.blur[field2] = $rootScope.blur[field3];
                $rootScope.blur[field3] = false;
            }
        };

        $scope.chooseEdit = function (fiscal) {
            if ($scope.form.show.changePass) {
                $scope.changePassword();
            }
            else {
                $scope.editProfile(fiscal);
            }
        };

        var previousPhone = "";
        $scope.checkPhone = function () {
            if (!/^[0-9]*$/.test($scope.form.phone)) {
                $scope.form.phone = previousPhone;
            }
            else {
                previousPhone = $scope.form.phone;
            }
        };

        $scope.$watch('form.dropImage', function(newValue) {
            if (newValue) {
                $scope.checkImage("dropImage");
                $scope.form.image = {};
            }
        });

        $scope.checkImage = function (item) {
            $scope.forms.check.image = false;
            if ($scope.form[item].filetype.indexOf('image') < 0) {
                $scope.forms.check.image = true;
                $scope.forms.text.image = 'profile.forms.image.image-error-1';
                $scope.uploadingImage = $scope.form.image = $scope.form.dropImage = false;
            }
            else if ($scope.form[item].filesize > 2097152) {
                $scope.forms.check.image = true;
                $scope.forms.text.image = 'profile.forms.image.image-error-2';
                $scope.uploadingImage = $scope.form.image = $scope.form.dropImage = false;
            }
        };

        $scope.uploadImage = function() {

            console.log("CHECK IMAGE 1", $scope.form.image);
            console.log("CHECK IMAGE 2", $scope.form.dropImage);

            console.log("UPLOAD IMAGE");
            $scope.uploadingImage = true;
            if (!$scope.forms.check.image) {
                if ($scope.form.dropImage) {
                    if ($scope.form.dropImage.base64.indexOf(';base64,') > -1) {
                        $scope.form.image.base64 = $scope.form.dropImage.base64.substring($scope.form.dropImage.base64.indexOf(';base64,') + 8);
                    }
                    else {
                        $scope.forms.check.image = true;
                        $scope.forms.text.image = 'profile.forms.image.image-error-1';
                        $scope.uploadingImage = $scope.form.image = $scope.form.dropImage = false;
                    }
                }
                var params = {
                    profileImageData: $scope.form.image.base64
                };
                $http.put(Configuration.apiUrl + '/senders', params, {
                    headers: {
                        'x-token': localStorage.getItem('xtoken'),
                        'x-userid': localStorage.getItem('userid')
                    }
                })
                    .then(function successCallback(response) {
                        console.log(response);
                        $scope.forms.show.image = $rootScope.blur.profileImage = $rootScope.blur.profileImageForced = false;
                        toolsService.setFalse($scope.forms.check);
                        $scope.uploadingImage = false;
                        getUserGeneralInfo();
                    }, function errorCallback(data) {
                        console.log(data);
                        $scope.uploadingImage = false;
                        $scope.forms.check.image = true;
                        $scope.forms.text.image = 'profile.forms.image.image-error-1';
                        $scope.form.image = $scope.form.dropImage = false;
                    });
            }
            else {
                $scope.uploadingImage = false;
                $scope.forms.check.image = true;
                $scope.forms.text.image = 'profile.forms.image.image-error-1';
                $scope.form.image = $scope.form.dropImage = false;
            }
        };

        $scope.editProfile = function (fiscal) {
            if ($scope.form.phone.length == 9 && $scope.form.name && (!fiscal ||  ($scope.form.cif && $scope.form.fiscalAddress && $scope.form.socialDenomination))) {
                var params = {
                    firstName: $scope.form.name,
                    lastName: "",
                    phone: $scope.form.phone
                };

                if(fiscal) {
                    params.cif = $scope.form.cif;
                    params.fiscalAddress = $scope.form.fiscalAddress;
                    params.socialDenomination = $scope.form.socialDenomination;
                }

                $http.put(Configuration.apiUrl + '/senders', params, {
                        headers: {
                            'x-token': localStorage.getItem('xtoken'),
                            'x-userid': localStorage.getItem('userid')
                        }
                    })
                    .then(function successCallback() {
                        if (fiscal) {
                            $scope.forms.show.fiscalInfo = $rootScope.blur.profileFiscalInfo = $rootScope.blur.profileFiscalInfoForced = false;
                        }
                        else {
                            $scope.forms.show.info = $rootScope.blur.profileInfo = $scope.form.show.changePass = $rootScope.blur.profileInfoForced = false;
                        }
                        getUserGeneralInfo();
                        if(!$scope.invoices || ($scope.invoices && $scope.invoices.length == 0)) {
                            getUserInvoices();
                        }

                    }, function errorCallback(data) {
                        console.log("ERROR EDIT");
                        console.log(data);
                        if (fiscal) {
                            $scope.forms.check.cif = true;
                            $scope.forms.text.cif = data.message;
                        }
                        else {
                            $scope.forms.check.name = true;
                            $scope.forms.text.name = data.message;
                        }
                    });
            } else {
                if (!$scope.form.name){
                    $scope.forms.check.name = true;
                    $scope.forms.text.name = "profile.errors.name";
                }
                if ($scope.form.phone.length != 9) {
                    $scope.forms.check.phone = true;
                    $scope.forms.text.phone = "profile.errors.phone";
                }
                if (fiscal) {
                    if (!$scope.form.cif) {
                        $scope.forms.check.cif = true;
                        $scope.forms.text.cif = "profile.errors.cif";
                    }
                    if (!$scope.form.fiscalAddress) {
                        $scope.forms.check.fiscalAddress = true;
                        $scope.forms.text.fiscalAddress = "profile.errors.fiscalAddress";
                    }
                    if (!$scope.form.socialDenomination) {
                        $scope.forms.check.socialDenomination = true;
                        $scope.forms.text.socialDenomination = "profile.errors.socialDenomination";
                    }
                }
            }
        };

        /* Get user info */

        function getUserGeneralInfo() {
            console.log("getUserGeneralInfo");
            $http.get(Configuration.apiUrl + '/senders/me', {
                    headers: {
                        'x-token': localStorage.getItem('xtoken'),
                        'x-userid': localStorage.getItem('userid')
                    }
                })
                .then(function successCallback(response) {
                    var aux1 = $scope.user.info;
                    var aux2 = $scope.user.promotions;

                    $scope.user = response.data;
                    if (aux1) {
                        $scope.user.info = aux1;
                    }
                    if (aux2) {
                        $scope.user.promotions = aux2;
                    }

					$rootScope.user.firstName = response.data.firstName;
					$rootScope.user.lastName = response.data.lastName;
					$rootScope.user.email = response.data.email;
					$rootScope.user.phone = response.data.phone;
					$rootScope.user.imageUrl = response.data.imageUrl;
					$rootScope.user.referralUrl = response.data.referralUrl;
					$rootScope.user.popup = response.data.popup;
					$rootScope.isUserLogged = true;
					if (response.data.referralUrl){
						$rootScope.clipboardTextButton = response.data.referralUrl.substr(response.data.referralUrl.indexOf("shargo.io"));
                    }
					if(response.data.popup.mgmCompletedGuest){
						$rootScope.mgm.show.promotion = "refered"; //"refered" "invitation"
						$rootScope.blur.MGMPopUppromotion = true;
					}
					else if(response.data.popup.mgmCompletedHost.length > 0){
						$rootScope.mgm.list = response.data.popup.mgmCompletedHost;
						$rootScope.mgm.index = 0;
						$rootScope.mgm.show.promotion = "referral"; //"refered" "invitation"
						$rootScope.blur.MGMPopUppromotion = true;
					} else {
					    //Show fiscal reminder if not set
                        if (!$scope.user.cif) {
                            console.log("FISCAL ADDRESS NOT SET");
                            $timeout(function() {
                                $scope.activePopUp('fiscalMissing', 'fiscalInfoMissing', 'fiscalInfoMissingForced');
                                $scope.dialogFillFiscalInformation = true;
                            }, 500);

                        }
                    }
                }, function errorCallback(data) {
                    console.log("USER INFO ERROR");
                    console.log(data);
					$rootScope.isUserLogged = false;
                });
        }

        $scope.hideFiscalDialog = function() {
            $scope.cancelPopUp('fiscalMissing', 'fiscalInfoMissing', 'fiscalInfoMissingForced');
            $scope.dialogFillFiscalInformation = false;

        };

        function getUserTransportInfo() {
            $http.get(Configuration.apiUrl + '/senders/me/info', {
                headers: {
                    'x-token': localStorage.getItem('xtoken'),
                    'x-userid': localStorage.getItem('userid')
                }
            })
            .then(function (response) {
                $scope.user.info = response.data;
            }).catch(function (error) {
                console.log("Transport Error");
                console.log(error);
            });
        }

        function getUserPromotionsInfo() {
            $http.get(Configuration.apiUrl + '/senders/promotions', {
                headers: {
                    'x-token': localStorage.getItem('xtoken'),
                    'x-userid': localStorage.getItem('userid')
                }
            })
            .then(function successCallback(response) {
                $scope.user.promotions = response.data;

                if ($scope.user.promotions.length > 0) {
                    for (var promo in $scope.user.promotions) {
                        if ($scope.user.promotions[promo].promotion.type == "1") {
                            $scope.user.promotions[promo].prefix = $scope.user.promotions[promo].promotion.amount;
                            $scope.user.promotions[promo].text = "promotion.amount-discount";
                            $scope.user.promotions[promo].suffix = "";
                        }
                        else if ($scope.user.promotions[promo].promotion.type == "2") {
                            $scope.user.promotions[promo].prefix = $scope.user.promotions[promo].promotion.percentage * 100;
                            $scope.user.promotions[promo].text = "promotion.percentage-discount";
                            $scope.user.promotions[promo].suffix = "";
                        }
                        else if ($scope.user.promotions[promo].promotion.type == "3") {
                            $scope.user.promotions[promo].prefix = "";
                            $scope.user.promotions[promo].text = "promotion.free-delivery";
                            $scope.user.promotions[promo].suffix = "";
                        }
                        else if ($scope.user.promotions[promo].promotion.type == "4") {
                            $scope.user.promotions[promo].prefix = "";
                            $scope.user.promotions[promo].text = "promotion.fix-price";
                            $scope.user.promotions[promo].suffix = $scope.user.promotions[promo].promotion.amount + "€";
                        }
                        else if ($scope.user.promotions[promo].promotion.type == "5"){
                            $scope.user.promotions[promo].prefix = "";
                            $scope.user.promotions[promo].suffix = $scope.user.promotions[promo].promotion.amount + "€";
                            if($scope.user.promotions[promo].promotion.transport == 0) {
                                $scope.user.promotions[promo].text = "promotion.promo-5-bike";
                            } else if($scope.user.promotions[promo].promotion.transport == 1) {
                                $scope.user.promotions[promo].text = "promotion.promo-5-moto";
                            } else if($scope.user.promotions[promo].promotion.transport == 2) {
                                $scope.user.promotions[promo].text = "promotion.promo-5-car";
                            } else if($scope.user.promotions[promo].promotion.transport == 3) {
                                $scope.user.promotions[promo].text = "promotion.promo-5-van";
                            }else $scope.user.promotions[promo].text = $scope.user.promotions[promo].prefix = $scope.user.promotions[promo].suffix = "";
                        }
						else if ($scope.user.promotions[promo].promotion.type == "6") {
							$scope.user.promotions[promo].prefix = "";
							$scope.user.promotions[promo].text = "promotion.fix-transport";
							$scope.user.promotions[promo].suffix = "";
						}
						else if ($scope.user.promotions[promo].promotion.type == "7") {
							$scope.user.promotions[promo].prefix = "";
							$scope.user.promotions[promo].text = "promotion.invitations";
							$scope.user.promotions[promo].suffix = "";
						}
                        else $scope.user.promotions[promo].text = "";
                    }
                }

            }, function errorCallback(data) {
                console.log("PROMOTIONS ERROR");
                console.log(data);
            });
        }

        /* Change Password */

        $scope.changePassword = function () {
            if ($scope.form.actPass && $scope.form.newPass && $scope.form.againNewPass && $scope.form.newPass === $scope.form.againNewPass) {
                var params = {
                    currentPassword: $scope.form.actPass,
                    newPassword: $scope.form.newPass
                };

                $http.post(Configuration.apiUrl + '/senders/password/change', params, {
                        headers: {
                            'x-token': localStorage.getItem('xtoken'),
                            'x-userid': localStorage.getItem('userid')
                        }
                    })
                    .then(function successCallback(response) {
                        $scope.forms.show.info = $rootScope.blur.profileInfo = $scope.form.show.changePass = $rootScope.blur.profileInfoForced = false;
                    }, function errorCallback(error) {
                        console.log("ERROR", error.data.message);
                        $scope.forms.check.actPass = true;
                        $scope.forms.text.actPass = error.data.message;
                    });
            }
            else {
                if (!$scope.form.actPass) {
                    $scope.forms.check.actPass = true;
                    $scope.forms.text.actPass = "profile.errors.actPass";
                }
                if (!$scope.form.newPass) {
                    $scope.forms.check.newPass = true;
                    $scope.forms.text.newPass = "profile.errors.newPass";
                }
                if (!$scope.form.againNewPass) {
                    $scope.forms.check.againNewPass = true;
                    $scope.forms.text.againNewPass = "profile.errors.againNewPass";
                }
                if ($scope.form.newPass && $scope.form.againNewPass && $scope.form.newPass !== $scope.form.againNewPass) {
                    $scope.forms.check.newPass = true;
                    $scope.forms.text.newPass = "profile.errors.pass-not-match";
                }
            }
        };


        /* Get Promotion */

        $scope.addPromotion = function () {
            if (!$scope.promoCode) {
                $scope.forms.check.promotion = true;
                $scope.forms.text.promotion = "profile.errors.promotion";
            }
            else {
                var params = {
                    promoCode: $scope.promoCode.toUpperCase()
                };
                $http.post(Configuration.apiUrl + '/senders/promotions', params, {
                    headers: {
                        'x-token': localStorage.getItem('xtoken'),
                        'x-userid': localStorage.getItem('userid')
                    }
                })
                    .then(function successCallback() {
                        $scope.forms.show.promotion = $rootScope.blur.profilePromotion = $scope.form.show.promotion = $rootScope.blur.profilePromotionForced = false;
                        getUserPromotionsInfo();
                    }, function errorCallback(data) {
                        console.log("ERROR PROMOTION");
                        console.log(data);
                        $scope.forms.check.promotion = true;
                        $scope.forms.text.promotion = "profile.errors.promotion";
                    });
            }
        };

        /* Logout Method */

        $scope.logout = function () {
            $http.get(Configuration.apiUrl + '/auth/signout', {
                    headers: {
                        'x-token': localStorage.getItem('xtoken'),
                        'x-userid': localStorage.getItem('userid')
                    }
                })
                .then(function successCallback(response) {
                    AuthService.logout();
                    $rootScope.isUserLogged = false;
                }, function errorCallback(data) {
                    AuthService.logout();
                    $rootScope.isUserLogged = false;
                }).finally(function() {
				    $window.location.href = '/';
			});
        };

    });
})();